import React from 'react';

import { ScrollReveal } from '../ScrollReveal';

export function HorizontalRule() {
  return (
    <ScrollReveal>
      <div className="block-container" data-testid="horizontal-rule">
        <div className="layout px-3 tablet:px-12 -mx-2 tablet:-mx-3 desktop:-mx-4">
          <div className="box-column w-10/12 flex-col px-2 tablet:px-3 desktop:px-4">
            <hr className="border-t border-[#1D252C] w-full my-4" />
          </div>
        </div>
      </div>
    </ScrollReveal>
  );
}
